module.exports = __webpack_public_path__ + "media/images/mobility/check-arrow-e11c084a31be9b52246d9c4a80d61081.svg";